import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
  },
  title: {
    borderBottom: '3px solid #b9bebe',
    paddingBottom: '18.6px',
    color: '#000',
    fontSize: '30px',
    lineHeight: '45px',
    fontFamily: 'Noto Sans JP',
    marginTop: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeigth: '30px',
      letterSpacing: '0.28px',
      paddingBottom: '15px',
    },
  },
  content: {
    marginTop: '20px',
    fontSize: '16px',
    color: '#6f7878',
    letterSpacing: '0.05em',
    lineHeight: 1.5,
    wordWrap: 'break-word',
    fontWeight: 500,
    fontFamily: 'Noto Sans JP',
    [theme.breakpoints.down('sm')]: {
      marginTop: '17px',
      fontSize: '13px',
      lineHeigth: '21px',
      letterSpacing: '0.28px',
    },
  },
  homeBtn: {
    paddingTop: '4.375em',
    paddingBottom: '0.62em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      paddingTop: '56px',
      paddingBottom: '12px',
    },

    '& button': {
      color: '#999999',
      border: '1px solid #999999',
      fontSize: '16px',
      lineHeight: '24px',
      textAlign: 'center',
      fontWeight: 400,
      background: 'transparent',
      padding: '6px 25px',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        padding: '5px 22px',
        fontSize: '13px',
        lineHeight: '21px',
      },
    },

  },
}));

export default useStyles;
